// import 'bootstrap/dist/css/bootstrap.css';
import './NavBar.css';
import './../dropdowns/Dropdown.css';

import React from 'react';
import ServiceBus from './../services/ServiceBus.ts';
import Dropdown from '../dropdowns/Dropdown.tsx';
import Item from '../dropdowns/DropdownItem.ts';
import { useState, useEffect, useRef } from 'react';
import { backend } from '../constants/constants.js';

function NavBar() {
  const serviceBus = new ServiceBus();
  const [apps, setApps] = useState([] as Item[]);
  const [services, setServices] = useState([] as Item[]);
  const [products, setProducts] = useState([] as Item[]);

  useEffect(() => {
    serviceBus.getApps().then((res) => setApps(res));
    serviceBus.getServices().then((res) => setServices(res));
    serviceBus.getProducts().then((res) => setProducts(res));
  }, []);

  return (
    <>
      <div className={'header'}>
        <a href="https://thedezlab.com/">
          <img className={'title-logo'} src={backend + 'logo'} />
          <div className={'title-left'}>TheDezLab | Automating Your Future</div>
        </a>
        <div className={'pages'}>
          <ul className={'page-list'}>
            <li>
              Products
              <Dropdown items={products}></Dropdown>
            </li>
            <li>
              Services
              <Dropdown items={services}></Dropdown>
            </li>
            <li>
              Apps
              <Dropdown items={apps}></Dropdown>
            </li>
            <li>Support</li>
            <li>Forums</li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default NavBar;
